import { render, staticRenderFns } from "./PaymentRejectedUpgrade.vue?vue&type=template&id=4355d2a6&"
import script from "./PaymentRejectedUpgrade.vue?vue&type=script&lang=js&"
export * from "./PaymentRejectedUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports